import { defineMessage } from 'services/localization';

export const messages = {
    deleteButtonTitle: defineMessage('remove_the_matching'),
    billColumnName: defineMessage('bill'),
    totalAmount: defineMessage('total_amount_totalamount'),
    dateColumnName: defineMessage('date'),
    deleteConfirmationText: defineMessage('sure'),
    remove: defineMessage('remove'),
    date: defineMessage('date_1'),
    amount: defineMessage('amount_1'),
    accountColumnName: defineMessage('category'),
    descriptionColumnName: defineMessage('description'),
    taxColumnName: defineMessage('tax'),
    itemColumnName: defineMessage('productservice'),
    customerColumnName: defineMessage('customer'),
    amountColumnName: defineMessage('amount_currency_2'),
    remainingColumnName: defineMessage('remaining_currency'),
    qtyColumnName: defineMessage('qty'),
    unitPriceColumnName: defineMessage('rate'),
    classColumnName: defineMessage('class'),
};
